import { injectable, inject } from 'inversify';
import Request from '@framework/api/Rpc/Request';
import { type IDispatcherFactory } from '@dataroom/json-rpc-dispatcher';
import DITypes from '@dataroom/json-rpc-dispatcher/DITypes';
import { ICountry } from '@dataroom/entity/Country';
import { RpcSuccess } from '@dealroadshow/json-rpc-dispatcher';
import CountryRepositoryI from './CountryRepositoryI';

@injectable()
class PhysicalDeliveryRepository implements CountryRepositoryI {
  constructor(
    @inject(DITypes.JsonRpcDispatcher) private readonly rpc: IDispatcherFactory,
  ) {}

  requestCopy = async (
    payload: {
      token: string,
      dataroomName: string,
      firstName: string,
      lastName: string,
      phoneNumber: string,
      corporateEmail: string,
      companyName: string,
      addressLine1: string,
      copyCount: number,
      country: string,
      state: string,
      city: string,
      zipCode: string,
      additionalNotes?: string,
    },
  ): Promise<void> => {
    const request = new Request('physical_delivery.request_copy', payload);
    await this.rpc().call<RpcSuccess>(request);
  };

  getCountries = async (
    payload: {
      token: string,
    },
  ): Promise<Array<ICountry>> => {
    const request = new Request('physical_delivery.country_list', payload);
    const response = await this.rpc().call<RpcSuccess>(request);
    return response.getResult().payload as any as Promise<Array<ICountry>>;
  };

  hasAccess = async (
    payload: {
      dataroomName: string,
      token: string,
    },
  ): Promise<{ hasAccess: boolean }> => {
    const request = new Request('physical_delivery.has_access', payload);
    const response = await this.rpc().call<RpcSuccess>(request);
    return response.getResult().payload;
  };

  getDataroomDisplayName = async (
    payload: {
      token: string,
    },
  ): Promise<{ displayName: string }> => {
    const request = new Request('physical_delivery.dataroom_display_name', payload);
    const response = await this.rpc().call<RpcSuccess>(request);
    return response.getResult().payload;
  };

  getDataroomSettings = async (
    payload: {
      token: string,
    },
  ): Promise<{ docState: string, requestPhysicalCopy: boolean }> => {
    const request = new Request('physical_delivery.dataroom_settings', payload);
    const response = await this.rpc().call<RpcSuccess>(request);
    return response.getResult().payload;
  };
}

export default PhysicalDeliveryRepository;
